import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { HttpService } from "../../components/services/HttpService";
import { UserTypeConstants } from "../types/UserTypeConstants";
import { history } from '../../components/helpers/History';
import { AdminActions } from "../actions/AdminActions";
import { BackDropActions } from "../actions/BackDropActions";
import { AlertActions } from "../actions/AlertActions";
import { USER_ROLE } from '../../components/security/UserRole';



function* registerAdmin(action) {
  try {
    var user = action.user;
    var payload ={
      "firstName": user.firstName,
      "lastName": user.lastName,
      "username": user.email,
      "password": user.password,
      "telePhoneNo": user.phoneNo,
      "email": user.email,
      "status": user.status,
      "userRole": user.userRole,
      "hospitalId": user.hospitalId
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post,"/users/register",payload);
    if(response && response.status && "SUCCESS" === response.status){
      yield put(AlertActions.success('Registered successfully.'));
      yield put(AdminActions.registerAdminSuccess(response.result));
    }else{
      yield put(AdminActions.registrationFailiure(response.result));
    }
  } catch (e) {
    yield put(AdminActions.registerAdminFailiure(e));
  }
}

function* registerAdminSuccess(action) {
  try {
    yield put(BackDropActions.end());
    var userRole = action.data && action.data.userRole ? action.data.userRole:''; 
    setTimeout((userRole) => {
      if(userRole===USER_ROLE.HCP_ADMIN){
        history.push('/admin/hcp');
      }else {
        history.push('/admin');
      }
    }, 400);
    
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* registerAdminFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message.description));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* udpateAdmin(action) {
  try {
    var user = action.user;
    var payload ={
      "id":user.id,
      "firstName": user.firstName,
      "lastName": user.lastName,
      "telePhoneNo": user.phoneNo,
      "email": user.email,
      "status": user.status,
      "userRole": user.userRole,
      "hospitalId": user.hospitalId
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.put,"/users/update",payload);
    if(response && response.status && "SUCCESS" === response.status){
      yield put(AlertActions.success('Updated successfully.'));
      yield put(AdminActions.registerAdminSuccess(response.result));
    }else{
      yield put(AdminActions.registerAdminFailiure(response.result));
    }
  } catch (e) {
    yield put(AdminActions.registerAdminFailiure(e));
  }
}


function* getAllAdmin(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get,"/users/findAllByUserRole?userrole="+USER_ROLE.SYSTEM_ADMIN);
    if(response && response.status && "SUCCESS" === response.status){
      yield put(AdminActions.getAllAdminSuccess(response.result));
    }else{
      yield put(AdminActions.getAllAdminFailiure(response.result));
    }
  } catch (e) {
    yield put(AdminActions.getAllAdminFailiure(e));
  }
}

function* getAllHCPAdmin(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get,"/users/findAllByUserRole?userrole="+USER_ROLE.HCP_ADMIN);
    if(response && response.status && "SUCCESS" === response.status){
      yield put(AdminActions.getAllAdminSuccess(response.result));
    }else{
      yield put(AdminActions.getAllAdminFailiure(response.result));
    }
  } catch (e) {
    yield put(AdminActions.getAllAdminFailiure(e));
  }
}

function* getAllAdminSuccess(action) {
  try {
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* getAllAdminFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message.description));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* getUserById(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get,"/users/"+action.id);
    if(response && response.status && "SUCCESS" === response.status){
      yield put(AdminActions.getUserByIdSuccess(response.result));
    }else{
      yield put(AdminActions.getUserByIdFailiure(response.result));
    }
  } catch (e) {
    yield put(AdminActions.getUserByIdFailiure(e));
  }
}

function* getUserByIdSuccess(action) {
  try {
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* getUserByIdFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message.description));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}


function* updateSecretQuestion(action) {
  try {
    var payload = {
      "id": action.data.id,
      "userSecretQuestionDto": action.data.userSecretQuestionDto
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.put,"/users/update/secret/question",payload);
    if(response && response.status && "SUCCESS" === response.status){
      yield put(AlertActions.success('Secret question updated successfully.'));
      yield put(AdminActions.updateSecretQuestionSuccess());
      yield put(BackDropActions.end());
    }else{
      yield put(AlertActions.error(response.result.description));
      yield put(BackDropActions.end());
    }
  } catch (e) {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(e));
  }
}
function* getSecretQuestionsAnswers(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get,"/users/secret/question/"+action.id);
    if(response && response.status && "SUCCESS" === response.status){
      yield put(AdminActions.getSecretQuestionsAnswersSuccess(response.result));
      yield put(BackDropActions.end());
    }else{
      yield put(BackDropActions.end());
      yield put(AdminActions.getSecretQuestionsAnswersFailiure());
      
    }
  } catch (e) {
    yield put(AdminActions.getUserByIdFailiure(e));
  }
}




function* adminSaga() {
  yield takeEvery(UserTypeConstants.ADMIN_REGISTER_REQUEST, registerAdmin);
  yield takeEvery(UserTypeConstants.ADMIN_REGISTER_SUCCESS, registerAdminSuccess);
  yield takeEvery(UserTypeConstants.ADMIN_REGISTER_FAILURE, registerAdminFailiure);
  yield takeEvery(UserTypeConstants.ADMIN_GETALL_REQUEST, getAllAdmin);
  yield takeEvery(UserTypeConstants.ADMIN_GETALL_HCP_REQUEST, getAllHCPAdmin);
  yield takeEvery(UserTypeConstants.ADMIN_GETALL_SUCCESS, getAllAdminSuccess);
  yield takeEvery(UserTypeConstants.ADMIN_GETALL_FAILURE, getAllAdminFailiure);
  yield takeEvery(UserTypeConstants.GET_USER_BY_ID_REQUEST, getUserById);
  yield takeEvery(UserTypeConstants.GET_USER_BY_ID_SUCCESS, getUserByIdSuccess);
  yield takeEvery(UserTypeConstants.GET_USER_BY_ID_FAILIURE, getUserByIdFailiure);
  yield takeEvery(UserTypeConstants.ADMIN_UPDATE_REQUEST, udpateAdmin);
  yield takeEvery(UserTypeConstants.UPDATE_SECRET_QUESTION_REQUEST, updateSecretQuestion);
  yield takeEvery(UserTypeConstants.GET_SECRET_QUESTION_REQUEST, getSecretQuestionsAnswers);

  
  
  
}

export default adminSaga;
